import { useMemo } from "react";

import { Copy } from "components/icons/generated";
import { type TableCellAction } from "ds/components/Table/Row/CellContent";
import useCopyToClipboard from "hooks/useCopyToClipboard";

import useIacManagementAnalytics from "../useIacManagementAnalytics";
import { ResourcesSuggestions } from "../useIacManagementFilters/constants";

const useCellCopyAction = (column: ResourcesSuggestions, text: string): TableCellAction => {
  const { trackAnalytics } = useIacManagementAnalytics();
  const action = useCopyToClipboard(text, () =>
    trackAnalytics("Copy cell content clicked", { column })
  );

  return useMemo(
    () => ({
      icon: Copy,
      title: "Copy",
      onPress: action,
    }),
    [action]
  );
};

export default useCellCopyAction;
